const state = {
  auth: null,
  loginVisible: false,
  shareInfo: {
    title: '袋鼠团商城',
    desc: '让你的采购简单一点',
    link: `${location.origin}/#/group`,
    imgUrl: 'http://image.daishupei.com/supplier/image/FjAbIoomJNR6BU-Lwt6wMSF5z5s_.png'
  },
  userInfo: null,
  shareDialog: false,
  refundDialog: false,
  refundData: null,
  createOrderQurey: null
}

const mutations = {
  setAuth (state, data) {
    state.auth = data
  },
  setLoginVisible (state, data) {
    state.loginVisible = data
  },
  setUserInfo (state, data) {
    state.userInfo = data
  },
  setShareDialog (state, data) {
    state.shareDialog = data
  },
  setRefundDialog (state, data) {
    state.refundDialog = data
  },
  setRefundData (state, data) {
    state.refundData = data
  },
  changeShareInfo (state, data) {
    state.shareInfo = Object.assign({}, state.shareInfo, data)
  },
  setCreateOrderQurey (state, data) {
    state.createOrderQurey = data
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/group.js